export default {
  notes: {
    MAX: 5,
  },
  payments: {
    MAX: 10,
  },
  bookingRelations: {
    MAX: 10,
  },
  drivers: {
    MAX: 10,
  },
  companyDrivers: {
    MAX: 2,
  },
  companies: {
    MAX: 10,
  },
  bankingExports: {
    MAX: 10,
  },
  historyCalendarEvents: {
    MAX: 10,
  },
};
